import { TypedDefinition } from '@rehaje/core'

import { defaultLocales } from './constants'

import type { VariablePlugin } from './plugin'
import type { TypedSchema } from '@rehaje/core'

export class VariableDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      title: this.locales.type,
      type: 'Schema.String'
    },
    {
      name: 'id',
      title: this.locales.id,
      type: 'Schema.String'
    },
    {
      expect: {
        type: 'Schema.Any'
      },
      name: 'defaultValue',
      title: this.locales.defaultValue,
      type: 'Schema.Mustache'
    },
    {
      name: 'value',
      title: this.locales.value,
      type: 'Schema.Unknown'
    },
    {
      name: 'setValue',
      parameters: [
        {
          name: 'value',
          title: this.locales.setValue,
          type: 'Schema.Any'
        }
      ],
      title: this.locales.setValue,
      type: 'Schema.Function'
    }
  ]

  get locales(): typeof defaultLocales {
    return (this.plugin.props.locales ??
      defaultLocales) as typeof defaultLocales
  }

  get plugin(): VariablePlugin {
    return this.getPlugin()
  }
}
